module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/notes/notes.component.html
// module id = ./src/app/notes/notes.component.html
// module chunks = main